<template>
    <div class="study-log">
        <div class="title">学习记录</div>
        <div class="record-select">
            <el-select
                v-model="classSelected"
                placeholder="显示方式"
                style="width:300px;background-color:#eeeeee;margin-left:25px;"
                @change="handleChange()"
            >
                <el-option
                    v-for="item in classSelect"
                    :key="item.courseId"
                    :label="item.courseName"
                    :value="item.courseId"
                    size="medium"
                ></el-option>
            </el-select>
        </div>
            <div style="min-height:680px;overflow:auto;width:auto;border:1px #cccccc solid;position:relative;margin:10px 25px 70px 25px;padding-bottom: 60px;">
                <Nothing :show="recordList"></Nothing>
                <div class="list_wrap">
                    <div v-for="(item , index) in recordList" :key="item.id">
                    <div>
                        <div style="border-bottom:1px solid #e5e5e5;" class="course_wrap">
                            <p class="study-time"
                            >{{item.createTime ? item.createTime.substring(0,10) : ""}}</p>
                            <div class="study-long"
                            >
                                <p class="record-middle">学习总时长：{{caculateTime1(item.chapterStudyTime,1)}}</p>
                            </div>
                            <p class="study-detail"
                                @click="changeRecord(index,item.courseId,item.createTime,item.seatMealCourseId)"
                            >
                                <span v-if="showRecord[index]">
                                    <i class="el-icon-arrow-up"></i>收起详情
                                </span>
                                <span v-if="!showRecord[index]">
                                    <i class="el-icon-arrow-down"></i>展开详情
                                </span>
                            </p>
                            <div style="clear:both;"></div>
                        </div>
                        <!-- 学习记录下拉菜单 -->
                        <el-collapse-transition>
                            <div v-if="showRecord[index]" style="margin:0 10px 40px">
                                <div style="height:40px;line-height:40px;display:table;width:100%;font-size: 12px;" v-for="(subRecord) in subRecordList[index]" :key="subRecord.id">
                                    <!-- <el-row >
                                        <el-col :span="2"><div class="nowrap-one">{{subRecord.createTime ? subRecord.createTime.substring(11,16) : ''}}</div></el-col>
                                        <el-col :span="5"><div class="nowrap-one">时长：{{caculateTime(subRecord.chapterStudyTime,1)}}</div></el-col>
                                        <el-col :span="9"><div class="nowrap-one">课程：{{subRecord.courseName}}</div></el-col>
                                        <el-col :span="8"><div class="nowrap-one">章节：{{subRecord.sectionName}}</div></el-col>
                                    </el-row> -->
                                    <div class="record-detail">
                                        <div class="create-time">{{subRecord.createTime ? subRecord.createTime.substring(11,16) : ''}}</div>
                                        <div class="study-time">时长：{{caculateTime1(subRecord.chapterStudyTime,1)}}</div>
                                        <el-tooltip effect="light" placement="right" :content="subRecord.courseName">
                                            <div class="course-name nowrap-one">课程：{{subRecord.courseName}}</div>
                                        </el-tooltip>
                                        <el-tooltip effect="light" placement="right" :content="subRecord.sectionName">
                                            <div class="section-name nowrap-one">章节：{{subRecord.sectionName}}</div>
                                        </el-tooltip>

                                    </div>
                                </div>
                            </div>
                        </el-collapse-transition>
                    </div>
                </div>
                </div>

                <div style="margin-bottom:0px;text-align:right;position: absolute; right: 0;left: 0px;padding-right: 20px;bottom:0px" class="studynote-bottom">
                    <el-pagination
                        style="float:right;margin:20px 0 10px 0;"
                        @size-change="handleRecordSizeChange"
                        @current-change="handleRecordChange"
                        :current-page="recordPage.pageNum"
                        :page-sizes="[10,5]"
                        :page-size="recordPage.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="recordPage.total"
                    ></el-pagination>
                 </div>
            </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      classSelected: '0',
      classSelect: [
        // {
        //     courseName: "全部记录",
        //     courseId:'0'
        // },
        // {
        //     courseName: "中国民航管制员英语等级测试模拟考试软件",
        //     courseId:'ED2F9C779DCD406C91AC76D4705BF3B1'
        // },
        // {
        //     courseName: "管制员英语无线电陆空通话课程软件",
        //     courseId:'2C6FD119D1E94D438D88B8DA28D11AF9'
        // },
        // {
        //     courseName: "管制员ICAO特情英语课程软件",
        //     courseId:'51B7563A144D43F6B9D6D006D6FBFBEF'
        // },
        // {
        //     courseName: "管制员英语测试考试指南学习软件",
        //     courseId:'AC96AEB02E384FCFB4767EBA2948ADD1'
        // }
      ],
      enterpriseId: '',
      seatMealCorseIds: [],
      courseIds: [],
      trainClassId: '',
      yearStart: '',
      yearEnd: '',
      showRecord: [],
      recordList: [],
      countSection: [],
      subRecordList: [],
      recordPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created () {
    if (sessionStorage.token === '' || sessionStorage.token === undefined) {
      this.$message.info('请先登录')
      this.$router.push('/login')
    }
    this.getNearYear()
    // this.getEnterpriseId()
    // this.getAllCourse()
    this.showStudyRecord()
  },
  methods: {
    progress (learned, total) {
      let result = 0
      if (total && total !== 0) {
        result = (learned / total) * 100
        if (result > 100) {
          result = 100
        }
        return result
      } else {
        return result
      }
    },
    getCountSection (id) {
      for (let i = 0; i < this.countSection.length; i++) {
        if (id === this.countSection[i].id) {
          return this.countSection[i].value
        }
      }
    },
    handleChange () {
      this.recordPage.pageNum = 1
      this.showStudyRecord()
    },
    dateFormat (time) {
      var date = new Date(time)
      var year = date.getFullYear()
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return year + '-' + month + '-' + day
    },
    getNearYear () {
      let end
      let start
      end = new Date()
      start = new Date()
      end = end.setTime(end.getTime() - 3600 * 1000 * 24)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 366)
      start = this.dateFormat(start)
      end = this.dateFormat(end)
      this.yearStart = start
      this.yearEnd = end

      // 查询所有课程
      this.$ajax.post(`/enterprise-service/Setmeal/getAllCourses`, {}).then(res => {
        if (res.code == 200) {
          let item = {courseName: '全部', courseId: '', setmealCourseId: ''}
          res.data = res.data.filter(el => {
            if (el.courseId != 'ED2F9C779DCD406C91AC76D4705BF3B1') {
              return el
            }
          })
          res.data.forEach(el => {
            item.courseId += el.courseId + ','
            item.setmealCourseId += el.setmealCourseId + ','
          })
          console.log(res.data, 666)
          item.courseId = item.courseId.substr(0, item.courseId.length - 1)
          this.classSelect.push(item)
          this.classSelect = this.classSelect.concat(res.data)
          this.classSelected = this.classSelect[0].courseId
          this.handleChange()
        }
      })
    },

    getEnterpriseId () {
      // this.$ajax
      //     .post(
      //         "/enterprise-service/Enterprise/getEnterByEnterNumber",
      //         this.postData({
      //             enterpriseNum: localStorage.enterpriseNum,
      //         })
      //     )
      //     .then((res) => {
      //         this.enterpriseId = res.data.id
      //         this.getAllCourseId()
      //     })
      this.getAllCourseId()
    },
    getAllCourseId () {
      // this.$ajax.get(`/enterprise-service/Setmeal/getEnterAndSetmealByEnterpriseId?enterpriseId=${this.enterpriseId}`).then((res) => {
      this.$ajax.get(`/studyapp-service/courseApp/getAllCourseIds`).then((res) => {
        if (res.code === '200') {
          this.seatMealCorseIds = res.data
        }
      })
    },
    // getAllCourse () {
    //     this.$ajax
    //         .post(
    //             "/enterprise-service/tbCourseUser/findForPage",
    //             this.postData({
    //                 id: sessionStorage.userUuid,
    //             })
    //         )
    //         .then((res) => {
    //             if (res.data) {
    //                 for (let i = 0; i < res.data.length; i++) {
    //                     // this.classSelect.push(res.data[i])
    //                     this.courseIds.push(res.data[i].courseId)
    //                     this.seatMealCorseIds.push(res.data[i].setmealCourseId)
    //                     this.countSection.push({
    //                         id: res.data[i].courseId,
    //                         value: res.data[i].countSection,
    //                     })
    //                 }
    //             }
    //             this.showStudyRecord()
    //         })
    // },
    showStudyRecord () {
      // let courseId
      // let mealId = this.classSelected === "0" ? this.seatMealCorseIds.toString() : this.classSelected
      let type = this.classSelected === '0' ? '2' : ''
      this.showRecord = []
      this.subRecordList = []
      // if (this.classSelected === "0") {
      //     courseId = this.classSelect.map(el=>el.courseId).toString()
      // } else {
      //     for (let i = 0; i < this.classSelect.length; i++) {
      //         if (this.classSelected === this.classSelect[i].setmealCourseId) {
      //             courseId = this.classSelect[i].courseId
      //             break
      //         }
      //     }
      // }
      this.$ajax
        .post(
          '/studyapp-service/TbStudyLog/tbStudyLogByparam',
          this.postData({
            courseId: this.classSelected === '0' ? this.classSelect.map(el => el.courseId).toString() : this.classSelected,
            userId: sessionStorage.userUuid,
            type: 2,
            pageSize: this.recordPage.pageSize,
            pageNumber: this.recordPage.pageNum
          })
        )
        .then((res) => {
          this.trainClassId = res.data.trainClassId
          this.recordPage.total = res.data.totalCount
          this.recordPage.pageNum = res.data.pageNumber
          this.recordPage.pageSize = res.data.pageSize
          this.recordList = res.data.list
        })
    },
    handleRecordSizeChange (val) {
      this.recordPage.pageSize = val
      this.handleRecordChange(1)
    },
    handleRecordChange (val) {
      this.recordPage.pageNum = val
      this.showStudyRecord()
    },
    caculateTime1 (time, type) {
      var days = parseInt(time / (1000 * 60 * 60 * 24))
      var hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + days * 24
      var minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = (time % (1000 * 60)) / 1000
      let str = `${hours ? hours + '小时  ' : ''}${minutes ? minutes + '分钟  ' : ''}${seconds ? seconds.toFixed(0) + '秒  ' : ''}`
      return str
    },
    caculateTime (time, type) {
      var totalTime = ''
      if (time) {
        time = parseInt(time)
        let hours = (time / (1000 * 60 * 60)).toFixed(2)
        if (hours > 0) {
          hours = parseInt(hours)
        } else {
          hours = 0
        }
        let minutes = Math.round((time % (1000 * 60 * 60)) / (1000 * 60))

        if (hours === 0) {
          if (minutes <= 0) {
            if (type === 1) {
              totalTime = '不到1分钟'
            } else {
              totalTime = '学时已用完'
            }
          } else {
            totalTime = '' + parseInt(minutes) + '分钟'
          }
        } else {
          totalTime = '' + parseInt(hours) + '小时' + parseInt(minutes) + '分钟'
        }

        return totalTime
      } else {
        if (type === 1) {
          totalTime = '不到1分钟'
        } else {
          totalTime = '学时已用完'
        }
        return totalTime
      }
    },
    caculateTime2 (time, type) {
      var totalTime = ''
      if (time) {
        time = parseInt(time)
        let hours = (time / (1000 * 60 * 60)).toFixed(2)
        if (hours > 0) {
          hours = parseInt(hours)
        } else {
          hours = 0
        }
        let minutes = Math.round((time % (1000 * 60 * 60)) / (1000 * 60))
        if (hours === 0) {
          if (minutes <= 0) {
            if (type === 1) {
              totalTime = '不到1分钟'
            } else {
              totalTime = '学时已用完'
              if (type === 2) {
                totalTime = '0分钟'
              }
            }
          } else {
            totalTime = '' + parseInt(minutes) + '分钟'
          }
        } else {
          totalTime = '' + parseInt(hours) + '小时' + parseInt(minutes) + '分钟'
        }

        return totalTime
      } else {
        if (type === 1) {
          totalTime = '不到1分钟'
        } else {
          totalTime = '学时已用完'
        }
        return totalTime
      }
    },
    changeRecord (index, courseId, createTime, mealId) {
      if (!this.showRecord[index]) {
        let type = this.classSelected === '0' ? '1' : ''
        console.log(this.classSelected, '5265')
        // let courseIds = this.classSelected === "0" ? this.courseIds.toString() : courseId
        let courseIds = this.classSelected
        let seatMealCourseId = this.classSelected === '0' ? this.seatMealCorseIds.toString() : mealId
        this.showRecord[index] = this.$set(this.showRecord, index, true)
        this.$ajax
          .post(
            '/studyapp-service/TbUserCourse/getStudyLogList',
            this.postData({
              courseId: courseIds,
              userId: sessionStorage.userUuid,
              createTime: createTime,
              seatMealCourseId: seatMealCourseId,
              type: '1'
            })
          )
          .then((res) => {
            if (res.code === '200') {
              this.$set(this.subRecordList, index, res.data)
            }
          })
      } else {
        this.showRecord[index] = this.$set(this.showRecord, index, false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.study-log {
	width: 1020px;
	background: rgb(255, 255, 255);
    margin-left: 35px;
	.title {
		font-weight: normal;
		font-size: 16px;
		margin: 15px 0 25px;
		color: #333333;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        padding: 0 00px 10px;
        margin-left: 10px;
	}
	.el-progress-bar__inner {
		background-color: #a5c0e7;
	}
	.delete-list {
		.el-checkbox__input {
			top: -55px;
			position: relative;
		}
	}
	.record-middle {
		margin: 0;
		.el-progress-bar {
			width: 140px;
			display: inline-block;
			margin-left: 15px;
		}
	}
	.record-middle2 {
		margin: 0;
		.el-progress-bar {
			width: 140px;
			display: inline-block;
			margin-left: 15px;
		}
	}
	.studynote-bottom {
		.el-button--info.is-plain {
			color: #333333;
		}
		.el-button {
			margin-left: 15px;
		}
		.el-button--info.is-plain:hover {
			color: #333333;
			background-color: #eeeeee;
		}
		.el-button--info.is-plain:active {
			color: #333333;
			background-color: #eeeeee;
		}
		.el-button--info.is-plain {
			color: #333333;
			background-color: #eeeeee;
		}
	}
	.note-background {
		background-color: #f8f8f8;
		padding: 20px 25px;
		border: 1px #e5e5e5 solid;
		color: #333333;
		margin: 0;
		border-radius: 5px;
	}
	.note-background:hover {
		border-color: #1060ab;
    }
    .record-detail {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        margin: 0 30px;
        color:#333333;
        .create-time {
            width: 100px;
        }
        .study-time {
            width: 150px;
        }
        .course-name {
            width: 250px;
        }
        .section-name {
            width: 300px;
        }
    }

}
.list_wrap {
    margin: 10px 30px 0;
    .course_wrap {
        display:flex;
        justify-content:space-around;
        align-items: center;
        height: 50px;
        .study-long {
           flex: 1;
        }
        .study-time {
            margin:0;
            width:110px;
            margin:0 30px;
        }
        .study-detail {
            margin:0;
            margin-left:30px;
            cursor:pointer;
            width:100px;
        }
        .study-time, .study-long, .study-detail {
            color:#333333;
        }
    }
}
.nowrap-one{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>




// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/studyLog.vue